import React from "react";

// MATERIAL-UI
import { Grid, Link } from "@mui/material";

// ASSETS
import { CallToActionStyles } from "./styles/CallToAction.styles";
import clsx from "clsx";

interface CallToActionProps {
  color: string;
  dismiss?: boolean;
  children: JSX.Element;
}

/* 
  Add 'dismiss' prop to CallToAction component to enable the ability to dismiss the banner.
*/

const CallToAction = (props: CallToActionProps) => {
  const classes = CallToActionStyles();
  const [open, toggle] = React.useReducer((open) => !open, true);

  return (
    <Grid
      container
      className={clsx(classes.container, {
        [classes.dismiss]: !open,
      })}
      style={{ backgroundColor: props.color }}
    >
      <Grid item xs={12} container>
        {props.children}

        {props.dismiss && (
          <Grid item xs={12}>
            <Link color={"#FFFFFF"} className={classes.link} onClick={toggle}>
              Dismiss
            </Link>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default CallToAction;
